// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-menu{list-style-type:none;font-size:.9rem;line-height:2rem;color:rgba(0,0,0,.5)}.sub-menu-item:hover a{color:rgba(0,0,0,.75);cursor:pointer}.sub-menu-item a{color:rgba(0,0,0,.5)}.sub-menu-item a.active{color:rgba(0,0,0,.9)}.sidenav-mini-icon{width:34px;text-align:center}.sidenav-mini-icon,.sidenav-normal{-webkit-transition:all .1s ease 0s;transition:all .1s ease 0s}.sidenav-normal{padding-left:8px}", ""]);
// Exports
module.exports = exports;
